<template>
  <div class="tile">
    <div class="tile__container">
      <img
        loading="lazy"
        src="/static/icons/one_view.svg"
        alt="Enkelt kolonne visning"
        class="tile__img tile__img--extra-low-res"
        :class="{ 'tile__img--selected': tileView === 'default' }"
        @click.prevent="setTileView('default')"
      />
      <img
        loading="lazy"
        src="/static/icons/list_view.svg"
        alt="Liste visning"
        class="tile__img tile__img--extra-low-res"
        :class="{ 'tile__img--selected': tileView === 'list' }"
        @click.prevent="setTileView('list')"
      />
      <img
        loading="lazy"
        src="/static/icons/one_view.svg"
        alt="Enkelt kolonne visning"
        class="tile__img tile__img--low-res"
        :class="{ 'tile__img--selected': tileView === 'single' }"
        @click.prevent="setTileView('single')"
      />
      <img
        loading="lazy"
        src="/static/icons/two_view.svg"
        alt="Dobbelt kolonne visning"
        class="tile__img tile__img--low-res"
        :class="{ 'tile__img--selected': tileView === 'default' }"
        @click.prevent="setTileView('default')"
      />
      <img
        loading="lazy"
        src="/static/icons/list_view.svg"
        alt="Liste visning"
        class="tile__img tile__img--low-res"
        :class="{ 'tile__img--selected': tileView === 'list' }"
        @click.prevent="setTileView('list')"
      />
      <img
        loading="lazy"
        src="/static/icons/two_view.svg"
        alt="Dobbelt kolonne visning"
        class="tile__img tile__img--high-res"
        :class="{ 'tile__img--selected': tileView === 'double' }"
        @click.prevent="setTileView('double')"
      />
      <img
        loading="lazy"
        src="/static/icons/all_view.svg"
        alt="Tredobbelt kolonne visning"
        class="tile__img tile__img--high-res"
        :class="{ 'tile__img--selected': tileView === 'default' }"
        @click.prevent="setTileView('default')"
      />
      <img
        loading="lazy"
        src="/static/icons/list_view.svg"
        alt="Liste visning"
        class="tile__img tile__img--high-res"
        :class="{ 'tile__img--selected': tileView === 'list' }"
        @click.prevent="setTileView('list')"
      />
      <img
        loading="lazy"
        src="/static/icons/all_view.svg"
        alt="Tredobbelt kolonne visning"
        class="tile__img tile__img--extra-high-res"
        :class="{ 'tile__img--selected': tileView === 'default' }"
        @click.prevent="setTileView('default')"
      />
      <img
        loading="lazy"
        src="/static/icons/list_view.svg"
        alt="Liste visning"
        class="tile__img tile__img--extra-high-res"
        :class="{ 'tile__img--selected': tileView === 'list' }"
        @click.prevent="setTileView('list')"
      />
    </div>
  </div>
</template>

<script>
import UidMixin from '@shared/uid-mixin.vue'
import SearchComponentsMixin from '@search/search-components-mixin.vue'

export default {
  mixins: [SearchComponentsMixin, UidMixin],
  data() {
    return {
      isOpen: false,
    }
  },
  props: {
    eventBus: { default: null, type: Object },
    tileView: { default: 'default', type: String },
  },
  methods: {
    setTileView(tileView) {
      if (this.tileView === tileView) return
      this.eventBus.emit('tile-view-callback', tileView)
    },
  },
}
</script>

<style lang="scss">
@import 'Tile.scss';
</style>
